/* eslint-disable no-console */

import PropTypes from 'prop-types';
import { Component } from 'react';
import { trackEvent } from '../usage-tracking/clients/usageTracker';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getClickedModalCta } from 'conversations-inbox-lib/usage-tracking/inboxInteractionEvents';
import { jsx as _jsx } from "react/jsx-runtime";
const TrackedPrompt = ({
  promptName,
  trackingEventParams = getClickedModalCta
}) => WrappedPrompt => {
  var _class;
  if (!promptName) {
    console.error('TrackedPrompt requires that { promptName: `string` } be set in the first argurment');
    return null;
  }
  if (typeof trackingEventParams !== 'function' && typeof trackingEventParams !== 'object') {
    console.error('TrackedPrompt requires that { trackingEventParams } be set to an object or function');
    return null;
  }
  return _class = class extends Component {
    static get defaultProps() {
      return {
        ctaConfirmAction: 'confirmed',
        ctaRejectAction: 'canceled'
      };
    }
    constructor(props) {
      super(props);
      this.handleConfirm = this.handleConfirm.bind(this);
      this.handleReject = this.handleReject.bind(this);
    }
    track(action, args = []) {
      if (typeof trackingEventParams === 'function') {
        return trackEvent(trackingEventParams({
          ctaAction: typeof action === 'string' ? action : action(...args),
          subscreen2: promptName
        }));
      }
      return trackEvent(trackingEventParams);
    }
    handleReject(...args) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'onReject' does not exist on type 'Readon... Remove this comment to see the full error message
      const {
        onReject,
        ctaRejectAction
      } = this.props;
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'any[]' is not assignable to para... Remove this comment to see the full error message
      this.track(ctaRejectAction, args);
      onReject(...args);
    }
    handleConfirm(...args) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'onConfirm' does not exist on type 'Reado... Remove this comment to see the full error message
      const {
        onConfirm,
        ctaConfirmAction
      } = this.props;
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'any[]' is not assignable to para... Remove this comment to see the full error message
      this.track(ctaConfirmAction, args);
      onConfirm(...args);
    }
    render() {
      return /*#__PURE__*/_jsx(WrappedPrompt, Object.assign({}, this.props, {
        onConfirm: this.handleConfirm,
        onReject: this.handleReject
      }));
    }
  }, _class.displayName = 'TrackedPrompt', _class.propTypes = {
    ctaConfirmAction: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    ctaRejectAction: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    onConfirm: PropTypes.func.isRequired,
    onReject: PropTypes.func.isRequired
  }, _class;
};
export default TrackedPrompt;